/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useToast } from '@veneer/core';

import { OperationStatus } from 'src/types';
import { DeviceSharingRequestAction } from 'src/types/devices';
import ApiError from 'src/types/error';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

type DeviceSharingActionState = {
  status: OperationStatus;
  error: ApiError | null;
  action: DeviceSharingRequestAction | null;
  email: string | null;
};

const useDeviceSharingActionToast = (
  postDeviceSharingAction: DeviceSharingActionState
): void => {
  const { addToast } = useToast();
  const { translate } = useDependencyManagerContext();

  useEffect(() => {
    if (
      postDeviceSharingAction.status === OperationStatus.COMPLETED &&
      postDeviceSharingAction.action &&
      postDeviceSharingAction.email
    ) {
      const localeKey =
        postDeviceSharingAction.action === DeviceSharingRequestAction.EXTEND
          ? 'components.shared-devices-table.toasts.extend.success'
          : 'components.shared-devices-table.toasts.revoke.success';
      addToast({
        id: `react-device-management-mfe-shared-devices-table-toast-${postDeviceSharingAction.action.toLowerCase()}-completed`,
        text: translate(localeKey, {
          email: postDeviceSharingAction.email
        }),
        type: 'positive'
      });
    } else if (
      postDeviceSharingAction.status === OperationStatus.ERRORED &&
      postDeviceSharingAction.action &&
      postDeviceSharingAction.email
    ) {
      const is412 = postDeviceSharingAction.error?.details?.statusCode === 412;
      const isExtend =
        postDeviceSharingAction.action === DeviceSharingRequestAction.EXTEND;

      let failureLocaleKey: string;
      if (is412) {
        failureLocaleKey = isExtend
          ? 'components.shared-devices-table.toasts.extend.failure-already-expired'
          : 'components.shared-devices-table.toasts.revoke.failure-already-expired';
      } else {
        failureLocaleKey = isExtend
          ? 'components.shared-devices-table.toasts.extend.failure'
          : 'components.shared-devices-table.toasts.revoke.failure';
      }
      addToast({
        id: `react-device-management-mfe-shared-devices-table-toast-${postDeviceSharingAction.action.toLowerCase()}-errored`,
        text: translate(failureLocaleKey, {
          email: postDeviceSharingAction.email
        }),
        type: 'negative'
      });
    }
  }, [postDeviceSharingAction]);
};

export default useDeviceSharingActionToast;
